import { getRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import Announcement from '../models/announcement';
import showStatusCodeError from './logging.service';

const getAllAnnouncementsByOfficeId = async (id: string, date: Date, keycloak: KeycloakContext): Promise<Announcement[] | number> => {
  const apiResponse = await getRequest<Announcement[] | number>(
    `office-announcement/office-id/${id}?startDate=${new Date(0).toUTCString()}`,
    keycloak,
  );

  if (apiResponse.error || apiResponse.json === undefined) {
    showStatusCodeError(apiResponse.status);
    return apiResponse.status;
  }

  return apiResponse.json;
};

export default getAllAnnouncementsByOfficeId;
